import React from "react"
import {
    Mouse_1,
    Mouse_2,
    Mouse_3,
    Mouse_4,
    Mouse_5,
    Mouse_6,
    Mouse_7,
    Mouse_8,
} from "../assets/svg/index"

const NoData = () => {
    return <div className="animation-block">
        <div className="d-flex justify-content-between align-items-center w-100 p-5 overflow-hidden" style={{ width: "500px" }}>
            <section className="loading-container" style={{flexDirection:'column'}}>

                <span className="paws step-1"><Mouse_7 /></span>
                <span className="paws step-2"><Mouse_1 /></span>
                <span className="paws step-3"><Mouse_4 /></span>
                <span className="paws step-4"><Mouse_3 /></span>

            </section>
            <div>
                <div className="cat">
                    <div className="ear ear--left"></div>
                    <div className="ear ear--right"></div>
                    <div className="face">
                        <div className="eye eye--left">
                            <div className="eye-pupil"></div>
                        </div>
                        <div className="eye eye--right">
                            <div className="eye-pupil"></div>
                        </div>
                        <div className="muzzle"></div>
                    </div>
                </div>
                <p className="text-white text-center" style={{ fontWeight: "600" }}>No Data</p>
            </div>

            <section className="loading-container" style={{flexDirection:'column-reverse'}}>
                <span className="paws step-1"><Mouse_6 /></span>
                <span className="paws step-2"><Mouse_5 /></span>
                <span className="paws step-3"><Mouse_2 /></span>
                <span className="paws step-4"><Mouse_8 /></span>
            </section>
        </div>
    </div>
}

export default NoData;